/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellLav,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useState, useMemo} from 'react'
import {TabLavanderiaModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {LaundryModel, PointModel, SelectModel} from '../../../../model'
import {getLaundry, getPoint} from '../../../../services'
import {MasiveTicket} from '../form/MasiveDownloadTicketPDF'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useCompany, useClient, useSite, useCamp} from '../../../../../central/hooks'
import {getMasterService} from '../../../../../central/services'
import {getFormatDate} from '../../../../../../util/functions'
interface FormattedDate {
  fecha: string
  tiempo: string
}
const TableLaundry: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    selectedLav,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()
  const {searchValues, clearSearchValues} = useKhipu()
  const [point, setPoint] = useState<SelectModel[]>([])
  const [status, setStatus] = useState<SelectModel[]>([])
  const {companyList, getCompanyList} = useCompany()
  const {clientList, getClientList} = useClient()
  const {siteList, getSiteList} = useSite()
  const {campList, getCampList} = useCamp()

  const getLaundryList = async () => {
    setLoading(true)
    const response = await getLaundry(searchValues, pagination.currentPage)
    if (!response.data.error) {
      setPagination({
        perPage: 10,
        currentPage: pagination.currentPage,
        totalResults: response.data.total,
      })
      const dataInfo = response.data?.data || []
      if (dataInfo.length > 0) {
        dataInfo.forEach((objeto) => {
          let dateCreation = objeto.fechaRegistro ? getFormatDate(objeto.fechaRegistro) : ''
          let dateReception = objeto.fechaRecepcion ? getFormatDate(objeto.fechaRecepcion) : ''
          let dateProgram = objeto.fechaEntregaProgramada
            ? getFormatDate(objeto.fechaEntregaProgramada)
            : ''
          let dateOut = objeto.fechaSalida ? getFormatDate(objeto.fechaSalida) : ''
          objeto.fechaRegistro = dateCreation
            ? (dateCreation as FormattedDate).fecha + ' ' + (dateCreation as FormattedDate).tiempo
            : ''
          objeto.fechaRecepcion = dateReception ? (dateReception as FormattedDate).fecha : ''
          objeto.fechaEntregaProgramada = dateProgram ? (dateProgram as FormattedDate).fecha : ''
          objeto.fechaSalida = dateOut ? (dateOut as FormattedDate).fecha : ''
          return objeto
        })
      }

      setData(dataInfo)
    }

    setLoading(false)
  }
  const getPointList = async () => {
    let obj: PointModel = {
      isCombo: true,
    }
    const response = await getPoint(obj, pagination.currentPage)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setPoint(mappedSites)
  }

  const getStatus = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoLavanderia',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
        codigo: master.codigo,
      }))
      setStatus(mappedMaster)
    } catch (error) {
      setStatus([])
    }
  }

  useEffect(() => {
    getPointList()
    getStatus()
    getCompanyList()
    getClientList()
    getSiteList()
    getCampList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getLaundryList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getLaundryList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])
  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-laundry',
      },
      idToDelete: '',
      aditionalInformation: {
        ...currentTabItem.aditionalInformation,
        order: {
          isView: true,
        },
      },
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }
  const handleEditPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-laundry',
      },
      currentExternalTab: 0,
      idToDelete: '',
      aditionalInformation: {
        ...currentTabItem.aditionalInformation,
        order: {
          isView: false,
        },
      },
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }
  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getLaundryList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])

  useEffect(() => {
    const filterData = data.filter((item) => (selectedLav ? selectedLav.includes(item.id) : false))
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      laundrySelected: filterData,
    }
    changeCurrentTabItem(obj)
  }, [selectedLav])

  // console.log(currentTabItem)

  const columns: Column<LaundryModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelectLav={true} />,
        id: 'selection',
        Cell: ({...props}) => <KTableSelectionCellLav id={props.data[props.row.index].id} />,
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) =>
          isAllowed('EDITAR') ? (
            <div
              className='d-flex justify-content-left flex-shrink-0 ms-2'
              onClick={() => handleEditPanel(props)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='campamentoId'
            selecteable
            data={campList}
          />
        ),
        accessor: 'nombreCampamento',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro de orden' name='nroOrden' searcheable />
        ),
        accessor: 'nroOrden',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Punto de Lavandería'
            data={point}
            name='puntoId'
            selecteable
          />
        ),
        accessor: 'punto',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de boleta'
            name='tipoRecepcion'
            searcheable
          />
        ),
        accessor: 'tipoRecepcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro de boleta' name='nroBoleta' searcheable />
        ),
        accessor: 'nroBoleta',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de generación de orden'
            name='fechaRegistro'
            dateable
          />
        ),
        accessor: 'fechaRegistro',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Creado por' name='usuarioCreacion' searcheable />
        ),
        accessor: 'usuarioCreacion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Huésped' name='nombreResponsable' searcheable />
        ),
        accessor: 'nombreResponsable',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Número de documento'
            name='numeroDocumento'
            searcheable
          />
        ),
        accessor: 'numeroDocumento',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Empresa' name='empresa' searcheable />
        ),
        accessor: 'empresa',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Email' name='email' searcheable />
        ),
        accessor: 'email',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Teléfono' name='telefono' searcheable />
        ),
        accessor: 'telefono',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de recepción'
            name='fechaRecepcion'
            dateable
          />
        ),
        accessor: 'fechaRecepcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de entrega Programada'
            name='fechaEntregaProgramada'
            dateable
          />
        ),
        accessor: 'fechaEntregaProgramada',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha de Salida' name='fechaSalida' dateable />
        ),
        accessor: 'fechaSalida',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cantidad prendas'
            name='cantidadPrendas'
            searcheable
          />
        ),
        accessor: 'cantidadPrendas',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Cantidad KG' name='cantidadKG' searcheable />
        ),
        accessor: 'cantidadKG',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Bolsa' name='bolsaCorrelativo' searcheable />
        ),
        accessor: 'bolsaCorrelativo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Rotulado'
            name='rotuladoCorrelativo'
            searcheable
          />
        ),
        accessor: 'rotuladoCorrelativo',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Estado' data={status} name='estado' selecteable />
        ),
        accessor: 'estadoNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'companiaId'}
            selecteable
            data={companyList}
          />
        ),
        accessor: 'nombreCompania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'clienteId'}
            selecteable
            data={clientList}
          />
        ),
        accessor: 'nombreCliente',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Site'
            name={'siteId'}
            selecteable
            data={siteList}
          />
        ),
        accessor: 'nombreSite',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions_ver',
        Cell: ({...props}) => (
          <div className='d-flex'>
            {isAllowed('VER') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0 ms-2'
                onClick={() => handleEditPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </div>
        ),
      },
    ],
    [
      companyList,
      clientList,
      siteList,
      campList,
      status,
      point,
      selectedOn,
      data,
      // changeCurrentTabItem,
    ],
  )

  // useEffect(() => {
  //   setInitialPagination()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentTabItem.loadingTable])

  useEffect(() => {
    if (currentTabItem.loadingTable) {
      clearSelected()
      getLaundryList()
      changeCurrentTabItem({...currentTabItem, loadingTable: false, laundrySelected: []})
    }
  }, [currentTabItem.loadingTable])

  const setInitialPagination = async () => {
    const {data: response} = await getLaundry({}, pagination.currentPage)
    setPagination({
      perPage: 10,
      currentPage: 1,
      totalResults: response.total,
    })
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {}, [data])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getLaundryList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])
  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='w-100'>
          <KTable data={data} columns={columns as any} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableLaundryWrapper = () => {
  const {isAllowed} = useLavanderia()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Órdenes</Tab>
            {isAllowed('MASIVO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Generar masiva de tickets</Tab>
            )}
          </TabList>
          <TabPanel>
            <TableLaundry />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <MasiveTicket />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableLaundryWrapper}
